import { Helmet } from 'react-helmet';

const PageSettings = () => (
  <Helmet>
    <title>Parola Webáruház - Megrendelő</title>
  </Helmet>
);

export default PageSettings;
